import React from "react"
import { Row, Col, Container } from "react-bootstrap"
import { StaticQuery, graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import styled from "styled-components"

class Hero extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      height: 0,
      width: 0,
    }
  }

  updateDimensions = () => {
    if (this.state.height !== window.innerHeight) {
      this.setState({ height: window.innerHeight })
    }
    if (this.state.width !== window.innerWidth) {
      this.setState({ width: window.innerWidth })
    }
  }

  componentDidMount() {
    this.setState({ height: window.innerHeight, width: window.innerWidth })
    window.addEventListener("resize", this.updateDimensions)
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions)
  }

  render() {
    const Section = styled.section`
      position: relative;
      background-size: cover;
      background-repeat: no-repeat;
      @media (max-width: 767px) {
        background-size: 100%;
        margin-top: 100px;
        height: 250px;
      }
    `

    const Overlay = styled.div`
      width: 100%;
      display: flex;
      align-items: center;
      background-color: rgba(0, 0, 0, 0.4);
      @media (min-width: 768px) and (max-width: 1500px) {
        margin-bottom: 200px;
      }
      @media (max-width: 767px) {
        height: 250px !important;
      }
    `

    const Heading1 = styled.h1`
      font-size: 60px;
      font-family: Poppins;
      line-height: 70px;
      color: #fff;
      font-weight: bold;
      text-transform: uppercase;
      @media (min-width: 768px) {
        margin-left: 4px;
      }
      @media (min-width: 768px) and (max-width: 1400px) {
        font-size: 40px;
        line-height: 50px;
        padding-top: 120px;
      }
      @media (min-width: 1401px) and (max-width: 1600px) {
        font-size: 60px;
        line-height: 70px;
        padding-top: 30px;
      }
      @media (max-width: 767px) {
        font-size: 20px;
        line-height: 30px;
        margin-left: 2px;
        padding-top: 30px;
      }
    `

    const Heading2 = styled.h2`
      font-size: 30px;
      line-height: 40px;
      color: #fff;
      font-weight: 700;
      background: -webkit-linear-gradient(left, #c1eb18, #65ff00);
      background: -o-linear-gradient(right, #c1eb18, #65ff00);
      background: -moz-linear-gradient(right, #c1eb18, #65ff00);
      background: linear-gradient(to right, #c1eb18, #65ff00);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      @media (max-width: 767px) {
        font-size: 20px;
        line-height: 30px;
      }
    `

    const Content = styled.div`
      position: relative;
      z-index: 10;
      @media (min-width: 1025px) and (max-width: 1400px) {
        margin-bottom: 200px;
      }
    `

    const Separator = styled.div`
      height: 5px;
      width: 50px;
      background-color: #c1eb18;
      margin-bottom: 30px;
      @media (min-width: 768px) {
        margin-left: 6px;
      }
      @media (max-width: 767px) {
        margin-left: 2px;
      }
    `

    const BottomContent = styled.div`
      position: absolute;
      width: 100%;
      bottom: -14%;
      z-index: 2;
      @media (min-width: 1025px) and (max-width: 1400px) {
        bottom: -50%;
      }
      @media (max-width: 767px) {
        position: relative;
        bottom: 0;
      }
      @media (min-width: 768px) and (max-width: 1023px) {
        bottom: -25%;
      }
    `

    const ServiceCol = styled(Col)`
      padding: 0;
      border-right: #444;
      &.no-border {
        border-right: none;
      }
      @media (max-width: 500px) {
        border-right: none;
      }
    `

    const Service = styled.div`
      min-height: 300px;
      background-color: #fff;
      transition: 0.2s;
      display: flex;
      justify-content: center;
      flex-direction: column;
      &:hover {
        background-color: #c1eb18;
      }
    `
    const ServiceContent = styled.div`
      padding: 40px;
      color: #fff;
    `
    const ServiceHeading3 = styled.h3`
      font-size: 30px;
      font-weight: 400;
      font-family: Antonio, sans-serif;
      color: #1a1a1a;
    `
    const ServiceSeparator = styled.div`
      height: 5px;
      width: 50px;
      background-color: #c1eb18;
      margin-bottom: 10px;
    `

    const ServiceIcon = styled.div`
      margin-bottom: 20px;
      img {
        max-height: 70px;
        max-width: 70px;
        width: 100%;
        height: auto;
      }
    `

    const ServiceText = styled.p`
      font-size: 14px;
      font-weight: 300;
      color: #444;
    `
    const Color = styled.span`
      font-weight: bold;
      color: #000000;
    `

    const { data } = this.props
    const imageData = getImage(data.background.childImageSharp.gatsbyImageData)

    return (
      <Section>
        <Overlay
          style={{
            height: `${this.state.width > 500 ? this.state.height : 220}px`,
          }}
        >
          <GatsbyImage
            image={imageData}
            alt="VASCO Solutions"
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              opacity: 0.7,
            }}
          />
          <Container>
            <Content>
              <Heading1>
                Certificados SSL en Colombia: Seguridad para Sitios, Apps y
                Plataformas
              </Heading1>
              <Heading2>Protege tus Proyectos con Certificados SSL</Heading2>
              <Separator />
            </Content>
          </Container>
        </Overlay>
        <BottomContent>
          <Container>
            <Row>
              <ServiceCol
                md={4}
                style={{
                  borderRight:
                    this.state.width > 500 ? "1px solid #444" : "none",
                }}
              >
                <Service>
                  <ServiceContent>
                    <ServiceIcon>
                      <GatsbyImage
                        image={this.props.image1}
                        alt="SSL sin acreditación ONAC en Colombia"
                      />
                    </ServiceIcon>
                    <ServiceHeading3>Sin Acreditación ONAC</ServiceHeading3>
                    <ServiceSeparator />
                    <ServiceText>
                      No necesitas ONAC para comprar o usar SSL en Colombia, a
                      pesar de mitos de competidores. Protege tu proyecto sin
                      complicaciones en Bogotá y Colombia.
                    </ServiceText>
                  </ServiceContent>
                </Service>
              </ServiceCol>
              <ServiceCol
                md={4}
                style={{
                  borderRight:
                    this.state.width > 500 ? "1px solid #444" : "none",
                }}
              >
                <Service>
                  <ServiceContent>
                    <ServiceIcon>
                      <GatsbyImage
                        image={this.props.image2}
                        alt="Certificados Digitales SSL con Garantía de reembolso 30 días"
                      />
                    </ServiceIcon>
                    <ServiceHeading3>Reembolso de 30 Días</ServiceHeading3>
                    <ServiceSeparator />
                    <ServiceText>
                      <Color>Prueba cualquier SSL sin riesgo.</Color> Si no
                      estás satisfecho, te devolvemos tu dinero en 30 días. Ya
                      sea que estés en Medellín, Cali, Pereira o Cartagena.
                    </ServiceText>
                  </ServiceContent>
                </Service>
              </ServiceCol>
              <ServiceCol md={4}>
                <Service>
                  <ServiceContent>
                    <ServiceIcon>
                      <GatsbyImage
                        image={this.props.image3}
                        alt="Certificados SSL en Colombia por tipo de validación o marca"
                      />
                    </ServiceIcon>
                    <ServiceHeading3>Tipos, CA o cantidad</ServiceHeading3>
                    <ServiceSeparator />
                    <ServiceText>
                      Elige por{" "}
                      <Color>
                        validación (DV, OV, EV), cantidad (Dominio único,
                        multidominio, Wildcard), o marca (DigiCert, Sectigo).
                      </Color>{" "}
                      Perfecto para Barranquilla y Cali.
                    </ServiceText>
                  </ServiceContent>
                </Service>
              </ServiceCol>
            </Row>
          </Container>
        </BottomContent>
      </Section>
    )
  }
}

const Iconos = (props) => (
  <StaticQuery
    query={graphql`
      {
        background: file(relativePath: { eq: "ssl-colombia.jpg" }) {
          childImageSharp {
            gatsbyImageData(layout: CONSTRAINED, width: 2000)
          }
        }
        image1: file(relativePath: { eq: "icons/alert2.png" }) {
          childImageSharp {
            gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
          }
        }
        image2: file(relativePath: { eq: "icons/medal2.png" }) {
          childImageSharp {
            gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
          }
        }
        image3: file(relativePath: { eq: "icons/ssl-colombia.png" }) {
          childImageSharp {
            gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
          }
        }
      }
    `}
    render={(data) => {
      const image1 = getImage(data.image1.childImageSharp.gatsbyImageData)
      const image2 = getImage(data.image2.childImageSharp.gatsbyImageData)
      const image3 = getImage(data.image3.childImageSharp.gatsbyImageData)
      return (
        <Hero
          data={data}
          image1={image1}
          image2={image2}
          image3={image3}
          {...props}
        />
      )
    }}
  />
)

export default Iconos
